import $ from "jquery";
import { Klass, u_ } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";
import "@pressmedia/vuwform";

import _initialize from "./_initialize";
import _attachPlugin from "./_attachPlugin";
import wysiwyg from "./wysiwyg";
import val from "./val";
import getFileUploaderProps from "./getFileUploaderProps";
import addFrame from "./addFrame";
import getCopiedInp from "./getCopiedInp";

/**
 * VuwWysiwygField (extends VuwTextField)
 * @options
	* - @required {String} paramKey
	* - @required {WebAppBase instance} app
	* - {Boolean} required
	* - {Number} ltd
	* - {String} placeholder
	* - {Boolean} useFrame
	* - {String} theme ("snow" or "bubble")
	* - {Object} config
	* - {Object} uploadCallbacks: {
	* 		begin($form) {},
	* 		onError(message) {},
	* 		onSelect(selectedFilePath, selectedFileName) {},
	* 		onDisSelect(paramKey) {},
	* 		onFileRead(ulFile, res) {},
	* 		onUpload(res) {},
	* 	}
 */
vuwer.appendKlass("VuwWysiwygField", {
	inpType: "wysiwyg",
	useFrame: false,
	boxClass: "wysiwyg-box",
	frameClass: "wysiwyg-frame",
	_initialize,
	_attachPlugin,
	...wysiwyg,
	...val,
	...getFileUploaderProps,
	...addFrame,
	...getCopiedInp,
	
	validate() {
		this.$self.attr("data-length", null);
		return Klass("VuwWysiwygField").parent.validate.call(this);
	},
	
	async onReadyFirst() {
		await this._promise;
		
		if( u_.isFunction(this._onReadyFirst) ) {
			return this._onReadyFirst(this.$self);
		}
	},
	
	getInpReady($self) {
		// DOMツリーに登録される前のことも考慮して、$self.findで取得する
		this.$inp = $self.find(`#inp_${this.idStr}`);
		if(this.$inp.length) {
			this.$inp.on("change.setVal", (e, isTrigger) => {
				!isTrigger && this.setVal(e.currentTarget.value, false, true);
			});
			
			// **** attachPlugin ****
			this._promise = Promise.all([
				this.useFrame && this._addFrame()
			]).then( this._attachPlugin.bind(this) );
			
			$.data(this.$inp.get(0), "vuwField", this);
			this.clearVal();
		}
		
		this.$inpHTML = $self.find(`#${this.$inp.attr("id")}_html`);
		
		return this;
	},
	
	_renderField() {
		const className = this.inpClassList.join(" ");
		const	elms = [];
		elms.push( $("<input/>").addClass(className).attr({
			type: "hidden",
			name: this.paramKey,
			id: `inp_${this.idStr}`
		}) );
		
		elms.push( $("<input/>").addClass(className).attr({
			type: "hidden",
			name: `${this.paramKey}_html`,
			id: `inp_${this.idStr}_html`
		}) );
		
		elms.push( $("<div/>").addClass(this.boxClass).attr("data-theme", this.theme) );
		
		return $.fn.append.apply(
			$("<fieldset/>").addClass("vuw-field field-wysiwyg").attr({
				"id": `field_${this.idStr}`,
				"data-name": this.paramKey
			}),
			elms
		);
	}
}, "VuwTextField");
